import {
  useGetHotelPurchase,
  useCreateHotelPurchase,
} from 'api-hooks/order/hotel';
import { HotelSaleModel } from 'api-hooks/sale/hotel';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import HotelPurchaseForm from './components/form';
import { HotelPurchaseFormType } from './components/form-type';

export type HotelPurchaseViewParams = {
  id: string;
  hotelSale?: HotelSaleModel;
  defaultValues?: HotelPurchaseFormType;
};

export default function HotelPurchaseView(
  props: NavigationProps<NavigationRoutes.HotelPurchasesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetHotelPurchase({
    id,
  });

  const { mutateAsync, error: errorMutate } = useCreateHotelPurchase();

  const hotelPurchase = data?.data;

  const onResolve = useApprovalableEdit('hotel-purchases');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <HotelPurchaseForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            hotelPurchase={hotelPurchase}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
